import axios from 'axios'
import { CATALOGO_ENDPOINT } from 'common/endpoints'

export async function getLabels() {
    const result = await axios.get(`${CATALOGO_ENDPOINT}/labels`)

    return result.data.data.map(elem => ({
      value: elem.id,
      label: elem.name
  }))
}
